import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useWorkflowCache } from './cache'
import { Logger, toResponseError, type WorkflowRemoveInput, type WorkflowRemoveSuccess } from '@terros/common'

const logger = new Logger('useRemoveWorkflow')

export function useRemoveWorkflow(): RemoveHookResponse<WorkflowRemoveInput> {
  logger.verbose('calling useRemoveWorkflow')
  const mutation = useTantalimMutation<WorkflowRemoveInput, WorkflowRemoveSuccess>({
    url: '/workflow/remove',
  })
  const cache = useWorkflowCache()

  async function remove(input: WorkflowRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.removeItem(input.workflowId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
